var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var _a;
// @ts-ignore
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import cxs from 'cxs/component';
import Theme, { logoCivitrip, marks, mediaQueries, strMark } from 'Theme';
import UserLogout from 'modules/Users/containers/UserLogout';
import { Logo, NavBarDesktop } from 'components';
import Icomoon from '../elements/Icomoon';
import NavBarMobile from './NavBarMobile';
import { Tooltip } from 'reactstrap';
import QueryParams from './QueryParams';
var TitleBar = /** @class */ (function (_super) {
    __extends(TitleBar, _super);
    function TitleBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /*render() {
      
          console.error('lang',lang)
          console.error('langAndRegion',langAndRegion)
      
          const {isDesktop} = this.props.store!.UI
          return (
            <Bar>
              {!isDesktop? <NavBarMobile/> : undefined}
              <Link to="/">
                {provider === providers.redsys ? (
                  <StyledLogo />
                ) : (
                  <StyledIcon name="logo" size={25} />
                )}
              </Link>
              {/!*{isDesktop ? <NavBarDesktop /> : <StyledLogout />}*!/}
              {isDesktop ? <NavBarDesktop /> : <StyledLogout />}
            </Bar>
          )
        }*/
        _this.state = {
            tooltip: false
        };
        _this.handleToggleTooltip = function () {
            _this.setState(function (prev) { return ({ tooltip: !prev.tooltip }); });
        };
        return _this;
    }
    TitleBar.prototype.render = function () {
        /*console.log('lang', lang)
        console.log('langAndRegion', langAndRegion)*/
        var _a;
        var version = process.env.REACT_APP_VERSION;
        var isDesktop = this.props.store.UI.isDesktop;
        var srcImage = '/logo_ticando.svg';
        var altImage = 'img ticando';
        var heighImage = '30px';
        var isCivitrip = ((_a = this.props.queryParams) === null || _a === void 0 ? void 0 : _a[strMark]) === marks.civitrip;
        if (isCivitrip) {
            srcImage = logoCivitrip;
            altImage = 'img civitrip';
            heighImage = '20px';
        }
        if (isDesktop) {
            return (React.createElement("div", { style: {
                    backgroundColor: 'whitesmoke',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    borderBottom: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
                    height: Theme.size.bar,
                    padding: "Theme.size.space[1] 0",
                    alignItems: 'center',
                } },
                React.createElement(Link, { to: "/" },
                    React.createElement("img", { src: srcImage, height: heighImage, width: '120px', alt: altImage, style: {
                            marginLeft: '30px',
                        } })),
                React.createElement("div", { style: {
                        /*background: 'salmon',*/
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    } },
                    React.createElement(NavBarDesktop, null),
                    React.createElement("div", { id: 'tooltip', style: { width: 10, height: 10 } }),
                    React.createElement(Tooltip, { target: 'tooltip', isOpen: this.state.tooltip, toggle: this.handleToggleTooltip, delay: 6000 }, version))));
        }
        return (React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                borderBottom: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
                backgroundColor: Theme.color.background
            } },
            React.createElement(NavBarMobile, { style: {
                    flex: 1
                } }),
            React.createElement("div", { style: {
                    flex: 5,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center'
                } },
                React.createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center'
                    } },
                    React.createElement(Link, { to: "/" },
                        React.createElement("img", { src: srcImage, height: heighImage, width: '120px', alt: altImage })))),
            React.createElement("div", { style: {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end'
                } },
                React.createElement(StyledLogout, null))));
    };
    TitleBar = __decorate([
        inject('store'),
        observer
    ], TitleBar);
    return TitleBar;
}(Component));
export default QueryParams(TitleBar);
var StyledText = cxs('p')({
    margin: 0,
    ':hover': {
        color: Theme.color.primary,
    },
});
var mobile = {};
var Bar = cxs('div')((_a = {
        display: 'flex',
        height: Theme.size.bar,
        padding: "Theme.size.space[1] 0",
        textAlign: 'center',
        borderBottom: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
        backgroundColor: Theme.color.background
    },
    _a[mediaQueries.desktop] = {
        flexShrink: 0,
        textAlign: 'left'
    },
    _a));
var center = {
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)'
};
var StyledIcon = cxs(Icomoon)({
    /*position: 'relative',*/
    /*top: '50%',*/
    /*transform: 'translateY(-50%)',*/
    ':hover': {
        color: Theme.color.primary
    },
});
var StyledLogo = cxs(Logo)({
    width: 'auto',
    height: '100%',
    border: '2px solid transparent',
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',
    ':hover': {
        color: Theme.color.primary
    }
});
var StyledLogout = cxs(UserLogout)({
    position: 'absolute',
    right: 0,
    top: Theme.common.size.bar / 2 + 'px',
    transform: 'translateY(-50%)'
});



//////////////////
// WEBPACK FOOTER
// ./src/components/TitleBar.tsx
// module id = 1045
// module chunks = 0